<template>
  <div class="flex justify-center">
    <div class="w-3/4">
      <div class="flex items-center justify-center">
        <img src="@/assets/images/invite_friend.png" alt="Image" class="mx-auto mb-4 w-64">
      </div>

        <h3 class="text-center font-bold mt-2" style="color: #552ac6">BETTER TOGETHER</h3>
        <h1 class="text-center font-bold mt-2 text-5xl">invite your friends</h1>

        <!-- <p class="text-center font-smaller mx-8 my-2">We have dropped the price so low to preserve and improve the happiness, productivity and work-life balance of others in these not easy times. Self Improvee is here for you.</p> -->

        <p class="text-center font-smaller font-grey mt-4">Taking on the journey with a friend makes you more accountable and it increases your success rate by 30%.</p>


      <div class="flex justify-center mt-2">
        <vs-button icon-pack="feather" icon="icon-users" color="#552ac6" class="mt-3" @click="doCopy" >invite</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

import { currentUserId } from '@/firebase/firebase'
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    userId () {
      return currentUserId()
    },
    toCopyMessage () {
      return `https://app.improvee.io/onboarding?channel=referral&inviter=${this.userId}`
    },
  },
  methods: {
    doCopy () {
      this.$copyText(this.toCopyMessage).then(() => {
        this.$store.dispatch('ADDITIONAL_USER_INFO', { inviteFriendCopy: true })

        this.$vs.notify({
          title: 'copied to clipboard 🔗',
          text: 'Together, we are going further! #improvetogether',
          color: '#552ac6',
          iconPack: 'feather',
          time: 10000,
          icon:'icon-users'})

        this.popupActive = false

        trackAnalytics(this, 'referral', 'invite_friend', null, this.$store.getters.daysFromRegistration)
      })
    }
  },
}
</script>
